module.exports = __webpack_public_path__ + "static/img/oddnary_bg.92d87184.jpg";